import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of, map } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE } = environment;

@Injectable({
  providedIn: 'root'
})

export class CustomerService {

    constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }

    //save Activity TImeline
    saveActivityTimeline(activityData: any) {
        const url = `${API_URLBLAZE}/user/screening/activityTime`;
        return this.http.post(url, activityData).pipe(catchError(this.handleError()));
    }

    //save Name Screening Remark
    saveNameScreeningRemark(nameScreeningData: any) {
      const url = `${API_URLBLAZE}/user/screening/nameScreeningRemark`;
      return this.http.post(url, nameScreeningData).pipe(catchError(this.handleError()));
  }

    //Update Customer Kyc Status by USER ID
    updateCustomerKycStatusChange(statusChangeRequest:any){
      const url = `${API_URLBLAZE}/user/customer/customerStatusChange`;
      return this.http.post(url, statusChangeRequest).pipe(catchError(this.handleError()));
    }

    //Update Customer Wallet Status by USER ID
    updateCustomerWalletStatusChange(req: any) {
    const url = `${API_URLBLAZE}/user/customer/customerWalletStatusChange/${req.status}/${req.userId}/${req.remark}`;
    return this.http.post(url, {}).pipe(
    catchError(this.handleError()));
    }

    //send request for screening for shufti pro
    sendScreeningRequestShuftiPro(screeningData: any) {
        const url = `${API_URLBLAZE}/user/kyc-screening/screeningUtility/shuftiPro`;
        return this.http.post(url, screeningData).pipe(catchError(this.handleError()));
    }


    //Update reviewFlag for customer by USER ID
    updateReviewFlag(reviewFlag:number,userId : String) {
      const url = `${API_URLBLAZE}/user/screening/kycScreeningResponse/${reviewFlag}/${userId}`;
      return this.http.post(url, null).pipe(catchError(this.handleError()));
  }

    //Get Customer Active List
    getCustomerActiveList(fullName:String,mobileNumber:String,status:String,kycStatus:String,emailId:string,dateFrom : string,dateTo : String,page_size:number,page_no:number,walletId?: string,emiratesId?: string) {
      var url = "";
      var filter = "";

      if(fullName != "" && fullName != undefined){
        filter = filter+`&fullName=${fullName}`
      }
      if(mobileNumber != "" && mobileNumber != undefined){
        filter = filter+`&mobileNumber=${mobileNumber}`
      }
      if(emailId != "" && emailId != undefined){
        filter = filter+`&emailId=${emailId}`
      }
      if(walletId) filter += `&walletId=${walletId}`;
      if(emiratesId) filter += `&governmentId=${emiratesId}`;
      if(kycStatus != "" && kycStatus !=null){
        filter = filter+`&kycStatus=$in=${kycStatus}`
      }else{
        filter = filter+`&kycStatus=$in=Not Yet Initiated,New,Inprocess,Successful,Expired`
      }
      if(status != "" && status != null){
        filter = filter+`&status=$in=${status}`
      }
      // else{
      //   filter = filter+`&status=$ne=BLOCKED`
      // }
      filter = filter+`&sort_dir=DESC`
      filter = filter+`&sort_column=createdDate`
      url = `${API_URLBLAZE}/user/customer/customerList?page_size=${page_size}&page_no=${page_no}&userType=$in=CUSTOMER`+filter;
      return this.http.get(url).pipe(
        map((response: any) => {
          // Data from backend is already encrypted, use as-is
          if (response && response.content) {
            response.content = response.content.map((customer: any) => {
              return {
                ...customer,
                kycStatus: customer.kycStatus,      // Use encrypted data from backend
                currentTrack: customer.currentTrack // Use encrypted data from backend
              };
            });
          }
          return response;
        }),
        catchError(this.handleError())
      );
    }

    //Get Customer Active List
    getCustomerDropDown() {
      var url = "";
      var filter = "";
       filter = filter+`&kycStatus=$in=Inprocess,Successful,Potential Hit,Rejected`;
        // filter = filter+`&status=$ne=BLOCKED`;
      url = `${API_URLBLAZE}/user/customer/customerList?page_size=ALL&page_no=0&userType=$in=CUSTOMER`+filter;
      console.log(url);
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

       //Get Customer Active List
       getCurrencyList() {
        var url = "";
        url = `${API_URLBLAZE}/product/country/active?page_size=ALL`;
        console.log(url);
        return this.http.get(url).pipe(catchError(this.handleError()));
      }

      getCountriesForCrossBorderTransfer() {
        const url = `${API_URLBLAZE}/product/countries/CROSS_BORDER_TRANSFER`;
        console.log(url);
        return this.http.get(url).pipe(catchError(this.handleError()));
      }

     //Get Customer Alert List
     getCustomerAlertList(fullName:String,mobileNumber:String,dateFrom : string,dateTo : String,page_size:number,page_no:number) {
        var url = "";
        var filter = "";
        if(fullName != "" && fullName != undefined){
          filter = filter+`&fullName=${fullName}`
        }
        if(mobileNumber != "" && mobileNumber != undefined){
          filter = filter+`&mobileNumber=${mobileNumber}`
        }
        filter = filter+`&sort_dir=DESC`
        filter = filter+`&sort_column=createdDate`
        filter = filter+`&kycStatus=$in=Potential Hit`
        filter = filter+`&status=$in=NEW,UNDER_REVIEW`

        url = `${API_URLBLAZE}/user/customer/customerList?page_size=${page_size}&page_no=${page_no}&userType=$in=CUSTOMER`+filter;
        console.log(url);
        return this.http.get(url).pipe(catchError(this.handleError()));
      }


     getCustomerBlockedList(fullName:String,mobileNumber:String,dateFrom : string,dateTo : String,page_size:number,page_no:number,walletId?: string,
  emiratesId?: string,  id?: string,) {
     console.log("inside method",id);
      var url = "";
      var filter = "";
      if(fullName != "" && fullName != undefined){
        filter = filter+`&fullName=${fullName}`
      }
      if(mobileNumber != "" && mobileNumber != undefined){
        filter = filter+`&mobileNumber=${mobileNumber}`
      }

      if(walletId) filter += `&walletId=${walletId}`;
      if(emiratesId) filter += `&emiratesId=${emiratesId}`;
    //  if(id) filter += `&id=${id}`;


      if(walletId) filter += `&walletId=${walletId}`;
      if(emiratesId) filter += `&emiratesId=${emiratesId}`;
    //  if(id) filter += `&id=${id}`;


      if(walletId) filter += `&walletId=${walletId}`;
      if(emiratesId) filter += `&emiratesId=${emiratesId}`;
    //  if(id) filter += `&id=${id}`;

      filter = filter+`&sort_dir=DESC`
      filter = filter+`&sort_column=createdDate`
      // filter = filter+`&kycStatus=$in=Rejected,Successful`
      filter = filter+`&status=$in=BLOCKED`
     if(id){
       filter = filter+`&id=$in=${id}`
     }

      url = `${API_URLBLAZE}/user/customer/customerList?page_size=${page_size}&page_no=${page_no}&userType=$in=CUSTOMER` + filter;
      url = `${API_URLBLAZE}/user/customer/customerList?page_size=${page_size}&page_no=${page_no}&userType=$in=CUSTOMER` + filter;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }


    // Get Customer List by Emirates ID
getCustomerByEmiratesId(fullName: string, mobileNumber: string, emiratesId: string, dateFrom: string, dateTo: string, page_size: number, page_no: number) {
  let url = "";
  let filter = "";

  if (fullName && fullName.trim() !== "") {
    filter += `&fullName=${fullName.trim()}`;
  }
  if (mobileNumber && mobileNumber.trim() !== "") {
    filter += `&mobileNumber=${mobileNumber.trim()}`;
  }
  if (emiratesId && emiratesId.trim() !== "") {
    filter += `&emiratesId=${emiratesId.trim()}`; // exact match
  }

  filter += `&sort_dir=DESC`;
  filter += `&sort_column=createdDate`;
filter = filter+`&status=$in=BLOCKED`
  url = `${API_URLBLAZE}/user/customer/customerListByEmiratesID?page_size=${page_size}&page_no=${page_no}&userType=$in=CUSTOMER` + filter;
  url = `${API_URLBLAZE}/user/customer/customerListByEmiratesID?page_size=${page_size}&page_no=${page_no}&userType=$in=CUSTOMER` + filter;

  console.log(url);
  return this.http.get(url).pipe(catchError(this.handleError()));
}



    //Get Customer Screening Response By Mobile Number
    getCustomerScreeningResponseById(mobileNumber: string) {
      const url = `${API_URLBLAZE}/user/screening/kycScreeningResponse/`+mobileNumber;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get Customer Information By Mobile Number
    getCustomerInfoResponseById(mobileNumber: string) {
        const url = `${API_URLBLAZE}/user/screening/userinfo/`+mobileNumber;
      //  const url = `http://localhost:8082/user/screening/userinfo/`+mobileNumber;
        return this.http.get(url).pipe(catchError(this.handleError()));
      }

    //Get Customer Activity Timeline By Screening ID
    getCustomerActivityById(screeningId: string) {
       const url = `${API_URLBLAZE}/user/screening/activityTime/`+screeningId;


      return this.http.get(url).pipe(catchError(this.handleError()));
      }

    //Get Customer Name Screening By Screening ID
    getCustomerNameScreeningById(screeningId: string) {
        const url = `${API_URLBLAZE}/user/screening/nameScreeningRemark/`+screeningId;
        return this.http.get(url).pipe(catchError(this.handleError()));
      }

    //Get Customer Status Change Audit By Mobile Number
    getCustomerStatusAudit(mobileNumber: string) {
      const url = `${API_URLBLAZE}/user/customer/statusChangeAudit/`+mobileNumber;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

     //Get Customer PDF Screening Report By Screening ID
     getCustomerPdfById(screeningId:any) {
      return this.http
        .get(
          `${API_URLBLAZE}/user/customer/screeningPdfReport/${screeningId}`,{
            observe:'response',
            responseType: 'blob'
          }
        );
    }

    getBalance() {
      return this.http
        .get(
          `https://testuatapi.pay10.asia/enbd/account/1014704140001/balance?idType=accountNumber`,{
          }
        );
    }


    downloadKycFile(formData: FormData){
      // return this.http
      //   .post(
      //     `${API_URLBLAZE}/download-uploadfiles`, formData
      //   );
      return this.http.get(`https://uatapi.pay10.ma/product/icon/get-profile?url=user/80690dbc-c1f2-4d18-9175-abbd5be3dd90_poa.pdf&lastModified=1735892494747`,);
    }

      private handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse): Observable<T> => {
          if (error.status == 401) {
            this.storageService.clean()
            this.router.navigate(['/auth/login']);
          }
          result = error?.error;
          return of(result as T);
        };
      }

    // Add this method to your CustomerService class
    getCustomerEvents(filters: any) {
      let queryParams = '';

      Object.keys(filters).forEach((key, index) => {
        queryParams += (index === 0 ? '?' : '&') + key + '=' + filters[key];
      });

       return this.http.get(`${environment.API_URLBLAZE}/user/customer-event/eventList${queryParams}`);
    // return this.http.get(`http://localhost:8082/user/customer-event/eventList${queryParams}`);

    }

    getEventConstants(userType?: string) {
      let url = `${environment.API_URLBLAZE}/user/customer-event/eventConstants`;
      // let url = `http://localhost:8082/user/customer-event/eventConstants`;

      if (userType) {
        url += `?userType=${userType}`;
      }

      return this.http.get(url)
        .pipe(catchError(this.handleError()));
    }

    getMerchantEvents(filters: any) {
      let queryParams = '';

      Object.keys(filters).forEach((key, index) => {
        queryParams += (index === 0 ? '?' : '&') + key + '=' + filters[key];
      });

      return this.http.get(`${environment.API_URLBLAZE}/user/merchant-event/eventList${queryParams}`)
      // return this.http.get(`http://localhost:8082/user/merchant-event/eventList${queryParams}`)
        .pipe(catchError(this.handleError()));
    }

    /**
     * Encrypt PII field for security - simulating backend encryption
     * In production, this would be done on the backend
     */
    private encryptPiiField(value: string): string {
      if (!value) return '';

      // Simple encryption simulation using XOR with a key
      const secretKey = environment.piiSecretKey || 'test-key-123';
      const encoder = new TextEncoder();
      const decoder = new TextDecoder();

      try {
        const textBytes = encoder.encode(value);
        const keyBytes = encoder.encode(secretKey);

        // XOR encryption
        const encrypted = new Uint8Array(textBytes.length);
        for (let i = 0; i < textBytes.length; i++) {
          encrypted[i] = textBytes[i] ^ keyBytes[i % keyBytes.length];
        }

        // Convert to base64 for safe transmission
        return btoa(String.fromCharCode(...encrypted));
      } catch (error) {
        console.error('Encryption failed:', error);
        return value; // Return original value if encryption fails
      }
    }

    updateTopupStatus(req: any) {
    const url = `${API_URLBLAZE}/transaction/transaction-report/updateTopupStatus/${req.status}/${req.userId}/${req.remark}`;
    return this.http.post(url, {}).pipe(
    catchError(this.handleError()));
    }
}
